import React from 'react';

// Unframed section (handoff_app_design/README.md §4.2) — secondary information sitting directly
// on the page background, with an optional title row (title + a text link on the far side).
//
// Props:
//   title    — section title (700 17px text), optional.
//   action   — { label, onClick } or { label, href } rendered as a text link beside the title.
export default function Section({ title, action, className = '', children }) {
  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      {(title || action) && (
        <div className="flex items-baseline justify-between">
          {title && <span className="font-bold text-[17px] text-text">{title}</span>}
          {action && (
            action.href ? (
              <a href={action.href} className="font-bold text-sm text-accent">{action.label}</a>
            ) : (
              <button type="button" onClick={action.onClick} className="font-bold text-sm text-accent">
                {action.label}
              </button>
            )
          )}
        </div>
      )}
      {children}
    </div>
  );
}
